export * from './register.component'
export * from './register-step4/register-step4.component'
export * from './register-main-step/register-main-step.component';